import { Label } from '@/components/shadcn/ui/label';
import { cn } from '@/lib/cn';

interface FormLabelGroupProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function FormLabelGroup({
  label,
  htmlFor,
  required,
  children,
  className,
}: FormLabelGroupProps) {
  return (
    <div className={cn('grid w-full items-center gap-2', className)}>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </Label>
      {children}
    </div>
  );
}
